import customModal from "./customModal"


customModal.install = function(Vue) {
    Vue.component(customModal.name, customModal);
}

export default customModal
